<div class="animated fadeIn loading">
  <div class="resp-img-container m-auto">
    <img
      src="../../../assets/images/images/loader.gif"
      alt="{{ 'LOADING.TITLE' | transloco }}"
    />
  </div>
</div>
